import { APP_CONFIG } from '../../config';
import { get } from '../request';
import { ApiEndpoints } from '../apiEndpoints.constant';

export interface MagentaDiscountResponse {
  discountCode: string;
}

export const getMagentaDiscount = async (): Promise<MagentaDiscountResponse> => {
  return await get(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.magentaDiscount}`);
};
